angular
.module("avant.customer_applications.directives")
.directive('declinePartnerDisclaimer', ->
  return{
    restrict: 'A',
    scope:
      'declinePartnerDisclaimer': '&'
    template: """
      <div class="text-left text-muted margin-bottom-10">
        <b>Disclaimer:</b>
        {{declinePartnerDisclaimer().loan_offer.disclaimer}}
      </div>
    """
  }
)
